import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class SellersService {
  private apiUrl = `${environment.apiUrl}/sellers`;

  constructor(private http: HttpClient, private router: Router) {}

  getAll(): Observable<any> {

    return this.http.get(this.apiUrl, { observe: 'response' }).pipe(
      map(response => {
        if (response.status !== 200) {
          throw new Error('Erro ao buscar sellers');
        }
        return response.body;
      })
    );
  }
}
